import styled, { css } from "styled-components";
import buildColor from "../../_static/ColorPalette";
import { fontNormal } from "../../_static/Typography";

export const SectionContainer = styled.section`
  position: relative;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  min-height: 178px;
  padding-top: 66px;

  @media only screen and (min-width: 768px) {
    padding-top: 0;
    min-height: auto;
    margin-top: 34px;
  }
`;

export const RowContainer = styled.div`
  ${({ alignCenter }) =>
    alignCenter
      ? css`
          display: flex;
          justify-content: center;
        `
      : ""};

  @media only screen and (min-width: 768px) {
    display: flex;
    justify-content: center;
    position: relative;
  }
`;

export const Title = styled.h1`
  color: ${buildColor("white", "100")};
  font-family: ${fontNormal};
  font-weight: 700;
  text-align: center;
  font-size: 24px;
  margin-bottom: 4px;

  @media only screen and (max-width: 767.98px) {
    padding: 0 52px;
  }

  @media only screen and (min-width: 768px) {
    margin-bottom: 0;
    max-width: 480px;
    text-align: center;
  }
`;

export const Description = styled.p`
  color: ${buildColor("blue", "000")};
  font-family: ${fontNormal};
  font-weight: 400;
  text-align: center;
  white-space: pre-wrap;
  font-size: 14px;

  @media only screen and (max-width: 767.98px) {
    padding: 0 20px;
    margin-bottom: ${({ hasPromo }) => (hasPromo ? "16px" : "20px")};
  }

  @media only screen and (min-width: 768px) {
    max-width: 334px;
    text-align: center;
    margin-top: ${({ hasPromo }) => (hasPromo ? "12px" : "8px")};
  }
`;

export const Button = styled.button`
  align-self: center;
  background-color: transparent;
  font-family: ${fontNormal};
  font-weight: 500;
  font-size: 12px;
  color: ${buildColor("blue", "100")};
  text-decoration: underline;

  @media only screen and (max-width: 767.98px) {
    margin-bottom: 24px;
  }

  @media only screen and (min-width: 768px) {
    margin-top: 16px;
    cursor: pointer;
  }
`;

export const HeaderMaskWrapper = styled.div`
  width: 100%;
  padding: 0 52px 20px;

  @media only screen and (min-width: 768px) {
    align-self: center;
    width: 440px;
    padding: 0;
  }
`;
